module.exports = __webpack_public_path__ + "static/media/framingham.ab36a94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/framingham.png
// module id = 125
// module chunks = 0